import React from 'react'
import { Field } from 'formik'
import { TextareaAutosizeField } from '.'

const FieldNote: React.FC = ({}) => {
  return (
    <Field
      label={intl.formatMessage({ id: 'call / describe / note' })}
      name="note"
      horizontal={false}
      component={TextareaAutosizeField}
      minRows={1}
      // autoFocus
    />
  )
}

export default FieldNote
